<template>
  <div class="banner" v-if="hasSession">
    <img
      id="white-logo"
      title="MyInsights Studio"
      src="@/assets/MyInsights_Studio_white.png"
    />
    <transition name="loader">
      <div class="loader-wrapper" v-if="displayLoader">
        <div class="loader"></div>
      </div>
    </transition>
    <div class="slds-icon_container">
      <a
        class="doc-link"
        href="https://crmhelp.veeva.com/doc/Content/CRM_topics/MyInsightsStudio/StudioOverview.htm"
        target="_blank"
      >
        <svg class="info-icon">
          <use
            xlink:href="../assets/icons/utility-sprite/svg/symbols.svg#info_alt"
          ></use>
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  export default {
    name: "Banner",
    computed: {
      isFetchingLatestApps() {
        return Boolean(this.latestApps && this.latestApps.fetch);
      },
      displayLoader() {
        return Boolean(
          this.hasSession &&
            (!this.messages ||
              !this.apps ||
              !this.org ||
              this.isFetchingLatestApps)
        );
      },
      ...mapState(["apps", "org", "messages", "latestApps", "hasSession"])
    }
  };
</script>

<style scoped>
  .banner {
    background-color: var(--YELLOWISH_ORANGE);
    height: 60px;
    display: flex;
    align-items: center;
  }

  .doc-link {
    width: 1.5rem;
    margin-right: 1rem;
    height: 1.5rem;
  }

  .info-icon {
    width: 1.5rem;
    height: 1.5rem;
    fill: var(--WHITE);
  }

  #white-logo {
    margin: auto;
    max-width: 17rem;
  }
</style>
